import { createSvgComponent } from "../../icon/createSvgComponent";
import CircleClose from "@core/icon/assets/circle-close.svg";
export default createSvgComponent(CircleClose);